<template>
  <div :class="{ 'sign-up-container': isSignUp }">
    <v-container fluid class="py-0">
      <v-row justify="center" align="center" class="session">
        <v-col class="d-flex justify-center">
          <div class="session__box">
            <transition name="fade-session" mode="out-in">
              <router-view
                class="animation-duration--500"
                :key="`session_${keyId}`"
                v-if="keyId"
              ></router-view>
            </transition>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "SessionLayout",
  computed: {
    ...mapState({
      selectedLocale: state => state.settings.selectedLocale
    }),
    keyId() {
      return `${this.selectedLocale}`;
    },
    isSignUp() {
      return this.$route.name === "session-sign-up";
    }
  },
  mounted() {
    window.dataLayer.push({
      user_id: ""
    });
  }
};
</script>

<style lang="scss">
.session {
  min-height: 100vh;
}

.session__box {
  margin: 0 auto;
  max-width: 730px;
  width: 100%;
  padding-top: $spacing * 9;

  @media (max-width: 1550px) {
    padding-top: $spacing * 8;
    max-width: 560px;
  }
}

.fade-session-enter-active {
  transition: opacity 0.2s ease, transform 0.2s ease;
}
.fade-session-leave-active {
  transition: opacity 0.5s ease, transform 0.5s ease;
}
.fade-session-enter,
.fade-session-leave-to {
  transform: translateX(-100px);
  opacity: 0;
}

.fade-session-leave-to,
.fade-session-enter-active {
  .grecaptcha-badge {
    visibility: hidden !important;
  }
}

.fade-session-enter {
  .grecaptcha-badge {
    visibility: visible !important;
  }
}

.sign-up-container {
  background: url("~@/static/session-sign-up-bg.jpg") no-repeat left top;
  background-size: cover;
}
</style>
